/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import axios from "axios";
import { getUserPreferences, setUserPreferences } from '../UserController/UserPreferences'

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Tabs,
  Tab,
  FormControl,
  FormGroup,
  FormLabel,
  FormControlLabel,
  Checkbox,
  Typography,
  CircularProgress,
  Badge,
  Divider,
  Switch,
  Tooltip,
  Hidden,
} from "@material-ui/core";

import { CheckBoxOutlineBlank, CheckBox } from '@material-ui/icons'
import Pagination from '@material-ui/lab/Pagination';
import Collapse from "@material-ui/core/Collapse";
import equal from "fast-deep-equal";

import Summary from "./components/Summary";
import ClassCard from "./components/ClassCard";

import Action from "../../fluid/Actions/ActionFactory";
import Viewer from "./components/FileViewers/Viewer";

import viewer_config from "./components/Config/viewer_config";

import SortList from './components/Sort/SortList'
import RecoFilter from './components/RecoFilter/RecoFilter'

import SplitterLayout from 'react-splitter-layout';
import 'react-splitter-layout/lib/index.css';

import SplitPane from 'react-split-pane';
import Pane from 'react-split-pane/lib/Pane'

const clone = require('rfdc')()

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const styles = (theme) => ({
  badge: {
    padding: `0 ${theme.spacing.unit * 2}px`,
  },
  splitter_class : {

  }
});

const default_sort = {
  all_results : {
    fields : [
      {
        field_name : "order",
        field_source : "operation"
      }
    ],
    direction : "ascending"
  },
  page : null
}


class Result extends Component {
  state = {
    tabValue: 0,
    rda_filters: [],
    selected_rdas: [],
    selected_record: null,
    location_index: 0,
    wv_server_url: null,
    wv_server_error: null,
    display_config: null,
    tab_panel_height: 0,
    content_height: 0,
    summary_height: 0,
    file_id: null,
    result_width : null,
    grouped: false,
    heading_height : 50,
    number_of_pages : 10,
    page_size : 10,
    cur_page : 1,
    sort : [],
    filters : [],
    viewer_size : 0
  };

  tab = React.createRef();
  iuList = React.createRef();
  summary_list = React.createRef()

  cancelTokenFunc = null;

  componentWillMount() {
    let rda_filters = this.getRdaFilter(0);
    let user_preference = getUserPreferences()

    if (user_preference.preferences.recommendation.settings.ic_view === undefined) {
      user_preference.preferences.recommendation.settings.ic_view = {}
      setUserPreferences(user_preference)
    }

    let grouped = user_preference.preferences.recommendation.settings.group_results
    let sorts = []
    let filters = []
    this.props.results.map(result => {
      let saved_sort = user_preference.preferences.recommendation.saved_sort_settings.find(sort => sort.ic_name === result.ic_name)
      if (saved_sort === undefined) {
        let sort = {
          ic_name : result.ic_name,
          sort_definition : default_sort
        }
        sorts.push(sort)
      } else {
        sorts.push(saved_sort)
      }

      let saved_filter = user_preference.preferences.recommendation.saved_filters.find(filter => filter.ic_name === result.ic_name)
      if (saved_filter === undefined) {
        let filter = {
          ic_name : result.ic_name,
          filters : []
        }
        filters.push(filter)
      } else {
        filters.push(saved_filter)
      }
    })

    this.setState({
      ...this.state,
      rda_filters: rda_filters,
      selected_rdas: rda_filters,
      tabValue: 0,
      selected_record: null,
      wv_server_error: null,
      display_config: null,
      sort : sorts,
      filters : filters,
      grouped : grouped
    }, () => console.log("Opening State : ", this.state));
    // this.setState({...this.state, ic_list : ic_list})
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeWindow());
    let tab_height = this.tab.current.clientHeight;
    let tab_width = this.tab.current.clientWidth;
    console.log("Prop Height :", this.props.height);
    console.log("Tab Height : ", tab_height);
    let tab_panel_height = this.props.height - tab_height;
    console.log("Tab Panel Height : ", tab_panel_height);
    let result_width;
    if (this.getClassResults().length > 0) {
      result_width = this.props.width * 0.75;
    } else {
      result_width = this.props.width ;
    }

    let user_preference = getUserPreferences()
    let viewer_size = result_width * 0.65
    // if (user_preference.preferences.recommendation.settings.ic_view !== undefined) {
    //   if (user_preference.preferences.recommendation.settings.ic_view[this.props.ic_list[0]] !== undefined) {
    //     viewer_size = user_preference.preferences.recommendation.settings.ic_view[this.props.ic_list[0]]
    //   }
    // }

    this.setState(
      {
        ...this.state,
        tab_panel_height: tab_panel_height,
        tab_panel_width : tab_width,
        result_width: result_width,
        viewer_size : viewer_size
      },
      () => {
        console.log("Tab Panel State : ", this.state);
        if (this.getResults(this.state.tabValue).length > 0) {
          let summary_height = this.state.tab_panel_height - this.state.heading_height + "px";
          console.log("Summary Height : ", summary_height);
          let results = this.getResults(this.state.tabValue)
          let number_of_pages = Math.ceil(results.length / this.state.page_size)
          this.setState(
            {
              ...this.state,
              summary_height: summary_height,
              number_of_pages : number_of_pages
            },
            () => {
              let first_record = this.getResults(this.state.tabValue)[0];
              let drl_required = this.isDrlRequired(first_record);
              this.selectRecord(
                first_record,
                drl_required,
                first_record.iu_record_src_info.iu_content_type.sub_type,
                first_record.source_link.path
              );
            }
          );
        }
      }
    );
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.width !== this.props.width || prevProps.height !== this.props.height) {
      this.resizeWindow()
    }
  }

  resizeWindow = () => {
    console.log("Resizing Window")
    let tab_height = this.tab.current.clientHeight;
    let tab_width = this.tab.current.clientWidth;
    console.log("Prop Height :", this.props.height);
    console.log("Tab Height : ", tab_height);
    let tab_panel_height = this.props.height - tab_height;
    console.log("Tab Panel Height : ", tab_panel_height);
    let result_width;
    if (this.getClassResults(this.state.tabValue).length > 0) {
      result_width = this.props.width * 0.8;
    } else {
      result_width = this.props.width ;
    }
    this.setState({
      ...this.state,
        tab_panel_height: tab_panel_height,
        tab_panel_width : tab_width,
        result_width: result_width,
    }, () => {
      if (this.getResults(this.state.tabValue).length > 0) {
        let summary_height = this.state.tab_panel_height - this.state.heading_height + "px";
        console.log("Summary Height : ", summary_height);
        this.setState(
          {
            ...this.state,
            summary_height: summary_height,
          }
        );
      }
      console.log("State Post Resize: ", this.state)
    })
  }

  handleTabChange = (event, newValue) => {
    let rda_filters = this.getRdaFilter(newValue);
    console.log("Content Height : ", this.state.content_height);
    let results = this.getResults(newValue)
    let number_of_pages = Math.ceil(results.length / this.state.page_size)
    let user_preference = getUserPreferences()
    let result_width;
    if (this.getClassResults(newValue).length > 0) {
      result_width = this.props.width * 0.75;
    } else {
      result_width = this.props.width ;
    }
    let viewer_size = this.state.result_width * 0.65
    // if (user_preference.preferences.recommendation.settings.ic_view !== undefined) {
    //   if (user_preference.preferences.recommendation.settings.ic_view[this.props.ic_list[newValue]]!== undefined) {
    //     viewer_size = user_preference.preferences.recommendation.settings.ic_view[this.props.ic_list[newValue]]
    //   }
    // }
    this.setState(
      {
        ...this.state,
        tabValue: newValue,
        rda_filters: rda_filters,
        selected_rdas: rda_filters,
        selected_record: null,
        location_index: 0,
        wv_server_error: null,
        display_config: null,
        number_of_pages : number_of_pages,
        cur_page : 1,
        result_width : result_width,
        viewer_size : viewer_size
      },
      () => {

        if (this.getResults(this.state.tabValue).length > 0) {
          // let iu_height = this.iuList.current.clientHeight;
          let summary_height = this.state.tab_panel_height - this.state.heading_height + "px";
          this.setState(
            { ...this.state, summary_height: summary_height},
            () => {
              let first_record = this.getResults(this.state.tabValue)[0]
              let drl_required = this.isDrlRequired(first_record);
              this.selectRecord(
                first_record,
                drl_required,
                first_record.iu_record_src_info.iu_content_type.sub_type,
                first_record.source_link.path
              );
            }
          );
        }
      }
    );
  };

  renderTabPanel = () => {
    return (
      <div
        style={{
          width: "100%",
          height: this.state.tab_panel_height,
          display: "flex",
          flexDirection: "row",
        }}
      >
        {/* {this.renderClassResults()} */}
        {this.renderRecoResults()}
      </div>
    );
  };

  saveFilter = (filter, ic_name) => {
    let new_filter = clone(this.state.filters)
    let filter_index = new_filter.findIndex(filter => filter.ic_name === ic_name)
    new_filter[filter_index] = filter
    this.setState({...this.state, filters: new_filter, cur_page : 1, selected_record : null}, () => {
      console.log("Saved Filter Definitions : ", this.state.filters)
      let results = this.getResults(this.state.tabValue)
      if (results.length > 0) {
        let first_record = results[0];
        console.log("Paginated Results post filter :", this.getPaginatedResults(results))
        let drl_required = this.isDrlRequired(first_record);
        this.selectRecord(
          first_record,
          drl_required,
          first_record.iu_record_src_info.iu_content_type.sub_type,
          first_record.source_link.path,
        );
      }
    })
  }

  saveSortDefs = (sort_def, ic_name) => {
    let new_sort = clone(this.state.sort)
    let sort_index = new_sort.findIndex(sort => sort.ic_name === ic_name)
    new_sort[sort_index] = sort_def
    this.setState({...this.state, sort : new_sort, cur_page : 1}, () => {
      console.log("Saved Sort Definitions : ", this.state.sort)
      let results = this.getResults(this.state.tabValue)
      let first_record = this.getPaginatedResults(results)[0];
      let drl_required = this.isDrlRequired(first_record);
      this.selectRecord(
        first_record,
        drl_required,
        first_record.iu_record_src_info.iu_content_type.sub_type,
        first_record.source_link.path,
      );
    })
  }

  renderRecoResults = () => {
    if (this.getRawResults(this.state.tabValue).length > 0) {
      return (
        <div
          style={{
            width : this.state.result_width,
            height: this.state.tab_panel_height,
          }}
        >
          <Paper
            variant="outlined"
            elevation={0}
            square
            style={{
              boxSizing: "border-box",
              width: "100%",
              height: this.state.heading_height + "px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              paddingRight : '15px'
            }}
          >
            <div style = {{
              boxSizing: "border-box",
              padding : '5px',
              height: this.state.heading_height + "px",
              display: "flex",
              flexDirection: "row",
              alignItems : "center",
              width : '40%'
            }}>
              <Typography variant="button">{this.props.reco_label}</Typography>
              <div 
                style = {{
                  flexGrow : 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems : "right",
                  justifyContent : 'flex-end'
                }}
              >
                <Pagination
                  color="primary" 
                  count = {Math.ceil(parseInt(this.getResults(this.state.tabValue).length / this.state.page_size))} 
                  siblingCount={0}
                  // siblingCount={2} 
                  // boundaryCount={2}
                  page = {this.state.cur_page}
                  onChange = {this.handlePageChange} 
                  size = 'small' 
                  showFirstButton 
                  showLastButton
                />
              </div>
            </div>
            <div style = {{
              boxSizing: "border-box",
              height: this.state.heading_height + "px", 
              borderLeft : '1px solid rgba(0,0,0,0.12)',
              width : '25%'
            }}>
                <RecoFilter
                  key = {this.props.ic_list[this.state.tabValue]}
                  // ic_name = {this.props.ic_list[this.state.tabValue]} 
                  ic_object = {this.getRecommendationResults(this.state.tabValue)} 
                  filters = {this.state.filters}
                  apply_filter = {(filter, ic_name) => this.saveFilter(filter, ic_name)}
                />
            </div>
            <div style = {{
              boxSizing: "border-box",
              height: this.state.heading_height + "px", 
              borderLeft : '1px solid rgba(0,0,0,0.12)',
              width : '25%'
            }}>
              <SortList 
                key = {this.props.ic_list[this.state.tabValue]}
                // ic_name = {this.props.ic_list[this.state.tabValue]} 
                ic_object = {this.getRecommendationResults(this.state.tabValue)} 
                sort_defs = {this.state.sort}
                apply_sort = {(sort_def, ic_name) => this.saveSortDefs(sort_def, ic_name)}
              />
            </div>
            <div style = {{
              width : '10%',
              boxSizing: "border-box",
              padding : '5px',
              height: this.state.heading_height + "px", 
              borderLeft : '1px solid rgba(0,0,0,0.12)',
              display: "flex",
              justifyContent: "center",
              alignItems : 'center',
              flexDirection: "row",
              marginRight : '10px'
            }}>
              <div>
                <FormControlLabel
                  control={
                    <Switch
                      color = 'primary'
                      size = 'small'
                      checked={this.state.grouped}
                      onChange={this.toggleGrouped}
                      name="grouped"
                    />
                  }
                  label={
                    <Typography variant="body1" color= {this.state.grouped ? "primary" : "textPrimary"} >
                      Group Results
                    </Typography>
                  }
                  labelPlacement="start"
                />
              </div>
            </div>
          </Paper>
          {this.renderResults(this.state.tabValue)}
        </div>
      );
    } else if (!this.props.searching) {
      return (
        <ThemeProvider theme={blue_theme}>
          <div
            style={{
              width: "100%",
              height: this.state.tab_panel_height,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography color="secondary" variant="caption">
              No {this.props.reco_label} from this Information Channel
            </Typography>
          </div>
        </ThemeProvider>
      );
    }
  };

  renderClassResults = () => {
    console.log(
      "Rendering Class : ",
      this.getClassResults()
    );
    if (this.getClassResults().length > 0) {
      return (
        <div
          style={{
            boxSizing: "border-box",
            width: "25%",
            marginRight: "3px",
            // height: this.state.tab_panel_height,
            borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
            overflow: "scroll",
          }}
        >
          <Paper
            variant="outlined"
            elevation={0}
            square
            style={{
              boxSizing: "border-box",
              padding: "5px",
              width: "100%",
              height: "50px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography variant="button">
              {this.props.class_label}
            </Typography>
          </Paper>
          {this.renderClassCards(this.getClassResults())}
        </div>
      );
    }
  };

  renderClassCards = (results) => {
    console.log("Classification Results : ", results)
    let cards = results.map((card) => {
      return <ClassCard label={card} />;
    });

    return cards;
  };

  renderRDAFilters = () => {
    const { classes } = this.props;
    console.log("RDA Filters :", this.state.rda_filters);
    console.log("Selected RDAs :", this.state.selected_rdas);
    if (this.state.rda_filters.length > 0) {
      return (
        <Paper
          ref={this.iuList}
          square
          style={{
            boxSizing: "border-box",
            backgroundColor: "#EEEEEE",
            maxWidth: "100%",
            overflowX: "scroll",
            padding: "5px",
            margin: "3px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography
              style={{ flexGrow: 1 }}
              variant="subtitle2"
              color="textSecondary"
            >
              Filters
            </Typography>
            <FormControlLabel
              style={{ marginRight: "5px" }}
              control={
                <Switch
                  color="secondary"
                  size="small"
                  checked={this.state.grouped}
                  onChange={this.toggleGrouped}
                  name="grouped"
                />
              }
              label={
                <Typography variant="body2" color="textSecondary">
                  Group Results
                </Typography>
              }
              labelPlacement="start"
            />
          </div>
          <Divider style={{ marginTop: "3px", marginBottom: "3px" }} />
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <FormControl>
              <FormLabel style={{ fontSize: 13 }}>Information Units</FormLabel>
              <FormGroup row>
                {this.state.rda_filters.map((rda) => {
                  return (
                    <FormControlLabel
                      style={{ fontSize: 12 }}
                      control={
                        <Checkbox
                          size="small"
                          color="primary"
                          checked={
                            this.state.selected_rdas.includes(rda)
                              ? true
                              : false
                          }
                          onChange={() => this.toggleRDA(rda)}
                        />
                      }
                      label={<Typography variant="subtitle2">{rda}</Typography>}
                    />
                  );
                })}
              </FormGroup>
            </FormControl>
          </div>
        </Paper>
      );
    }
  };

  toggleGrouped = () => {
    let user_preference = getUserPreferences()
    if (this.state.grouped === false) {
      user_preference.preferences.recommendation.settings.group_results = true
      setUserPreferences(user_preference)
      this.setState(
        {
          ...this.state,
          grouped: true,
          location_index: 0,
          selected_record: this.getResults(this.state.tabValue)[0].iu_record_id,
          cur_page: 1
        },
        () => {
          let results = this.getResults(this.state.tabValue)
          let number_of_pages = Math.ceil(results.length / this.state.page_size)
          this.setState({
            ...this.state, 
            number_of_pages : number_of_pages,
            cur_page: 1
          }, () => {
            let first_record = results[0]
            let drl_required = this.isDrlRequired(first_record);
            this.selectRecord(
              first_record,
              drl_required,
              first_record.iu_record_src_info.iu_content_type.sub_type,
              first_record.source_link.path
            );
          })
        }
      );
    } else {
      user_preference.preferences.recommendation.settings.group_results = false
      setUserPreferences(user_preference)
      this.setState(
        {
          ...this.state,
          grouped: false,
          location_index: 0,
        },
        () => {
          let results = this.getResults(this.state.tabValue)
          let number_of_pages = Math.ceil(results.length / this.state.page_size)
          this.setState({
            ...this.state, 
            number_of_pages : number_of_pages,
            cur_page : 1
          }, () => {
            let first_record = results[0];
            let drl_required = this.isDrlRequired(first_record);
            this.selectRecord(
              first_record,
              drl_required,
              first_record.iu_record_src_info.iu_content_type.sub_type,
              first_record.source_link.path
            );
          })
        }
      );
    }
  };

  toggleRDA = (cur_rda) => {
    let rda_index = this.state.selected_rdas.findIndex(
      (rda) => rda === cur_rda
    );
    let selected_rdas = [...this.state.selected_rdas];
    if (rda_index === -1) {
      selected_rdas.push(cur_rda);
      this.setState({ ...this.state, selected_rdas: selected_rdas });
    } else {
      selected_rdas.splice(rda_index, 1);
      this.setState({ ...this.state, selected_rdas: selected_rdas });
    }
  };

  getRdaFilter = (index) => {
    let rda_set = new Set();

    let results = this.getResults(index);
    results.forEach((record) => {
      rda_set.add(record.iu_key.user_friendly_name);
    });

    let rda = Array.from(rda_set);
    return rda;
  };

  filterResults = (result_list, ic_name) => {
    let filter = this.state.filters.find(filter => filter.ic_name === ic_name)
    if (filter !== undefined) {
      let filtered_results = []
      result_list.map(record => {
        let record_iu = record.iu_key.user_friendly_name
        let iu_filter = filter.filters.find(filter => filter.iu_name === record_iu)
        if (iu_filter !== undefined) {
          let field_filters = iu_filter.fields.filter(field => field.allowed_values.length > 0)
          let field_filter_pass = field_filters.map(field_filter => {
            let raw_field_value = record.raw_fields.fields.find(field => field.name === field_filter.name).value
            if (field_filter.allowed_values.includes(raw_field_value)) {
              return true
            } else {
              return false
            }
          })
          let field_filter_check = field_filter_pass.filter(field => field === false)
          if (field_filter_check.length === 0) {
            filtered_results.push(record)
          }
        } else {
          filtered_results.push(record)
        }
      })
      return filtered_results
    } else {
      return result_list
    }
  }

  sortResults = (result_list, context, ic_name) => {
      let sort_def = this.state.sort.find(sort => sort.ic_name === ic_name)
      if (sort_def !== undefined) {
        let context_sort = sort_def.sort_definition[context]
        console.log("Context Sort : ", context_sort)
        if (context_sort !== null) {
          let sort_on = context_sort.fields[0].field_source
          let sorted_result = result_list.sort((a,b) => {
            if (sort_on === "operation") {
              let sort_field = context_sort.fields[0].field_name
              return a[sort_field] - b[sort_field]
            } else {
              let a_iu = context_sort.fields.find(field => field.field_source === a.iu_key.user_friendly_name)
              let b_iu = context_sort.fields.find(field => field.field_source === b.iu_key.user_friendly_name)
              console.log("a_iu", a_iu)
              console.log("b_iu", b_iu)
              let a_sort_field
              let b_sort_field
              if (a_iu === undefined || b_iu === undefined) {
                return 0
              } else {
                a_sort_field = context_sort.fields.find(field => field.field_source === a.iu_key.user_friendly_name).field_name
                console.log("a_sort_field", a_sort_field)
                b_sort_field = context_sort.fields.find(field => field.field_source === b.iu_key.user_friendly_name).field_name
                console.log("b_sort_field", b_sort_field)
              }

              return a.raw_fields.fields.find(field => field.name === a_sort_field).value.localeCompare(b.raw_fields.fields.find(field => field.name === b_sort_field).value)
            }
          })

          if (context_sort.direction === 'descending') {
            sorted_result.reverse()
          }
          return sorted_result
        } else {
          return result_list
        }
      } else {
        return result_list
      }
      
  }

  getRawResults = (index) => {
    let raw_results = []
    let cur_ic_name = this.props.ic_list[index]
    if (this.props.results.length > 0) {
      let result_index = this.props.results.findIndex(result => result.ic_name === cur_ic_name)
      if (result_index !== -1) {
        raw_results = this.props.results[result_index].response.result
      }
    }

    return raw_results
  }

  getResults = (index) => {
    //let current_ic = this.state.ic_list[index]
    //let resultIndex = this.props.results.findIndex(ic => ic.ic_name === current_ic)
    let cur_ic_name = this.props.ic_list[index]
    if (this.props.results.length > 0) {
      let result_index = this.props.results.findIndex(result => result.ic_name === cur_ic_name)
      if (result_index !== -1) {
        let raw_results = this.props.results[result_index].response.result
        let filtered_results = this.filterResults(raw_results, this.props.results[result_index].ic_name)
        console.log("Reco Results Filtered: ", filtered_results);
        let sorted_results = this.sortResults(filtered_results, "all_results", this.props.results[result_index].ic_name)
        console.log("Reco Results Sorted : ", sorted_results);
        let results = this.props.results.length > 0 ? this.getGroupedResults(sorted_results, result_index) : [];
        console.log("Reco Results : ", results);
        return results;
      } else {
        return []
      }
    } else {
      return []
    }
  };

  getRecommendationResults = (index) => {
    let cur_ic_name = this.props.ic_list[index]
    let result_index = this.props.results.findIndex(result => result.ic_name === cur_ic_name)
    let raw_results = this.props.results[result_index]
    return raw_results
  }

  getGroupedResults = (results, index) => {
    //let current_ic = this.state.ic_list[index]
    //let resultIndex = this.props.results.findIndex(ic => ic.ic_name === current_ic)
    // let results = this.props.results[index].response.result;

    if (results.length > 0) {
      results.map((result) => {
        if (this.state.grouped) {
          if (
            // result.iu_record_src_info.iu_content_type.type === "DOC" ||
            result.iu_record_src_info.iu_content_type.type === "TABLE" ||
            result.iu_record_src_info.iu_content_type.type === "DATA"
          ) {
            result.grouped = true;
            result.group = [];
          } else {
            result.grouped = false;
            result.group = null;
          }
        } else {
          result.grouped = false;
          result.group = null;
        }
      });

      console.log("Group Label on Results : ", results)
      let sources = new Set();

      results.map((result) => {
        if (result.grouped) {
          let source = result.iu_record_src_info.iu_record_nav_info.source;
          sources.add(JSON.stringify(source));
        }
      });

      let source_eval = Array.from(sources);

      let eval_results = [];

      source_eval.forEach((source, i) => {
        let el_one = false;
        results.map((res) => {
          if (res.grouped) {
            let res_src = JSON.stringify(
              res.iu_record_src_info.iu_record_nav_info.source
            );
            if (source === res_src) {
              if (el_one === false) {
                eval_results[i] = res;
                eval_results[i].group.push(res);
                el_one = true;
              } else {
                eval_results[i].group.push(res);
              }
            }
          }
        });
      });

      results.map((res) => {
        if (res.grouped === false) {
          eval_results.push(res);
        }
      });

      // eval_results.sort((a, b) => {
      //   return parseInt(a.order) - parseInt(b.order);
      // });

      return eval_results;
    } else {
      return [];
    }
  };

  getClassResults = () => {
    let results = [];
    // let cur_ic_name = this.props.ic_list[index]
    if (this.props.class_results.length > 0) {
      // let class_index = this.props.class_results.findIndex(class_result => class_result.ic_name === cur_ic_name)
      // console.log("Class Results Class Index : ", class_index)
      // if (class_index !== -1) {
      //   let results_obj = this.props.class_results.find(res => res.ic_name === cur_ic_name)
      //   if (results_obj !== undefined) {
      //     results = results_obj.response.result
      //     // if (this.state.result_width !== null) {
      //     //   this.setState({...this.state, result_width : this.state.tab_width * 0.8})
      //     // }
      //   } else {
      //     // if (this.state.result_width !== null) {
      //     //   this.setState({...this.state, result_width : this.state.tab_width})
      //     // }
      //   }
      //   console.log("Class Results : ", results);
      // }

      let ic_class_results = this.props.class_results.map(class_result => {
        let ic_name = class_result.ic_name
        let classes = class_result.response.result.map(res => {
          res.ic_name = ic_name
          return res
        })
        return classes
      })

      console.log("Consolidated Classification : ", ic_class_results.flat())
      results = ic_class_results.flat()
    }
    return results;
  };

  handlePageChange = (event, value) => {
    let results = this.getResults(this.state.tabValue)
    this.setState({...this.state, cur_page : value}, () => {
      let paginated_results = this.getPaginatedResults(results)
      let first_record = paginated_results[0];
      let drl_required = this.isDrlRequired(first_record);
      this.selectRecord(
        first_record,
        drl_required,
        first_record.iu_record_src_info.iu_content_type.sub_type,
        first_record.source_link.path
      );
      this.summary_list.current.scrollTo(0, 0)
    })
  }

  getPaginatedResults = (results) => {
    console.log("Pre Paginated Results: ", results)
    let paginated_results = []
    let top_index = this.state.cur_page * this.state.page_size
    let lower_index = (this.state.cur_page - 1) * this.state.page_size
    results.map((result, i) => {
      if (i >= lower_index && i < top_index) {
        paginated_results.push(result)
      }
    })
    console.log("Post Paginated Results: ", paginated_results)
    let sorted_results = this.sortResults(paginated_results, "page", this.props.ic_list[this.state.tabValue])
    return sorted_results
  }

  renderResults = (index) => {
    let results = this.getResults(index);

    if (results.length === 0) {
      return (
        <div
          style={{
            width: "100%",
            height: "calc(" + this.state.tab_panel_height + "px -" + this.state.heading_height +  "px)",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography>No Results for this search.</Typography>
        </div>
      );
    } else {
      let paginated_results = this.getPaginatedResults(results)
      if (paginated_results === 0) {
        return (
          <div
          style={{
            width: "100%",
            height: "calc(" + this.state.tab_panel_height + "px -" + this.state.heading_height +  "px)",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography>No Results for this search.</Typography>
        </div>
        )
      } else {
        return (
          <div
            style={{
              width: "100%",
              height: this.state.tab_panel_height,
              // display: "flex",
              // flexDirection: "row",
              marginTop: "5px",
              overflow : "hidden"
            }}
          >
            {/* <SplitterLayout
              percentage = {true}
              secondaryInitialSize = {65}
            >
              
            </SplitterLayout> */}
            {/* <SplitPane 
              primary="second"
              split="vertical"
              minSize = '100%'
              // onChange={(size) => {
              //   var toPX = require("to-px");
              //   console.log("Resizing Reco: ", this.state.result_width - Number(size[0].substring(0, size[0].length - 2)))
              //   let user_preference = getUserPreferences()
              //   // if (user_preference.preferences.recommendation.settings.ic_view === undefined) {
              //   //   user_preference.recommendation.settings = {...user_preference.recommendation.settings, ic_view : {}}
              //   // }
              //   user_preference.preferences.recommendation.settings.ic_view[this.props.ic_list[this.state.tabValue]] = toPX('100vw') - Number(size[0].substring(0, size[0].length - 2))
              //   setUserPreferences(user_preference)
              //   this.setState({...this.state, viewer_size : this.state.result_width - Number(size[0].substring(0, size[0].length - 2))})
              // }}
            >
              <Pane 
                initialSize = "25%"
                // minSize = "10%"
              >
                {this.renderSummary(paginated_results)}
              </Pane>
              <Pane 
                initialSize = '75%'
              >
                {this.renderDetailView()}
              </Pane>
            </SplitPane> */}
            <div style = {{width : this.state.result_width, display : 'flex', flexDirection : 'row'}}>
              <div style = {{width : this.state.result_width * 0.2}}>
                {this.renderSummary(paginated_results)}
              </div>
              <div
                style = {{width : this.state.result_width * 0.8}}
              >
                {this.renderDetailView()}
              </div>
            </div>
          </div>
        );
      }
    }
  };

  renderSummary = (results) => {
    return (
      <div
        style={{
          //width: this.state.result_width * 0.35 + "px",
          height: "calc(" + this.state.tab_panel_height + "px -" + this.state.heading_height +  "px)",
          borderRight: "1px solid rgba(0,0,0,0.12)",
        }}
      >
        {/* {this.renderRDAFilters()} */}
        <div
          ref = {this.summary_list}
          style={{
            width: "100%",
            height: this.state.summary_height,
            backgroundColor: "#f2f2f2",
            padding: "5px",
            overflow: "scroll",
          }}
        >
          {results.map((record) => {
            let rda_name = record.iu_key.user_friendly_name;
            return (
              <Collapse
                in={this.state.selected_rdas.includes(rda_name) ? true : false}
              >
                <Summary
                  location_index={this.state.location_index}
                  key={record.iu_record_id}
                  record={record}
                  selected_record={this.state.selected_record}
                  selectRecord={(iu_record, drl_required, file_type) =>
                    this.selectRecord(iu_record, drl_required, file_type)
                  }
                  setLocation={(location_index) =>
                    this.setLocationIndex(location_index)
                  }
                  re_attach = {this.props.re_attach}
                  attach_options = {this.props.attach_options}
                  re_attach_attachment = {(field_option, attachment_object) => this.props.re_attach_attachment(field_option, attachment_object)}
                />
              </Collapse>
            );
          })}
        </div>
      </div>
    );
  };

  getViewerConfig = (record) => {
    let type = record.iu_record_src_info.iu_content_type.type;
    let sub_type = record.iu_record_src_info.iu_content_type.sub_type;

    let viewer_index = viewer_config.findIndex(
      (viewer) =>
        viewer.type.includes(type) && viewer.sub_type.includes(sub_type)
    );
    let view_config = viewer_config[viewer_index];

    return view_config;
  };

  isDrlRequired = (record) => {
    let view_config = this.getViewerConfig(record);
    return view_config.drl_required;
  };

  setLocationIndex = (location_index) => {
    this.setState({
      ...this.state,
      location_index: location_index,
    }, () => console.log("Setting Location Index : ", location_index));
  };

  selectRecord = (iu_record, drl_required, file_type, file_id) => {
    if (this.state.selected_record !== iu_record.iu_record_id) {
      let ic_name = iu_record.iu_key.containment.base.ic_id;
      let iu_name = iu_record.iu_key.user_friendly_name;
      this.setState(
        {
          ...this.state,
          selected_record: iu_record.iu_record_id,
          display_config: null,
          loading_viewer: true,
          drl_result: null,
          location_index: 0,
          file_id: file_id,
        },
        () => {
          let display_config = null;
          let wv_server = null;
          let drl_result = null;

          Action("http_request", {
            url:
              "/sainapse/information_channel/" +
              ic_name +
              "/information_unit/" +
              iu_name +
              "/display_config",
            method: "get",
            data: {},
          })
            .then((res) => {
              console.log("Display Config :", res.data.result);
              display_config = res.data.result;
              // && display_config !== null && display_config.display === null
              if (display_config.viewer === "data") {
                Action("http_request", {
                  url:
                    "/sainapse/world_view_server/" +
                    iu_record.source_link.symbolic_server_name,
                  method: "get",
                  data: {},
                })
                  .then((res) => {
                    console.log("WV_Server Result :", res.data);
                    wv_server = res.data.result.name;
                    if (drl_required) {
                      if (this.cancelTokenFunc) {
                        this.cancelTokenFunc();
                      }

                      let CancelToken = axios.CancelToken;

                      Action("http_request", {
                        url: this.props.drl_url + "/drl/file",
                        method: "get",
                        params: {
                          wv_server: wv_server,
                          file_type: file_type,
                          file_id: iu_record.source_link.file_id,
                        },
                        cancelToken: new CancelToken((c) => {
                          this.cancelTokenFunc = c;
                        }),
                        data: {},
                      })
                        .then((res) => {
                          drl_result = res.data;
                          console.log("DRL Result: ", res.data);
                          if (
                            this.state.selected_record ===
                            iu_record.iu_record_id
                          ) {
                            this.setState(
                              {
                                ...this.state,
                                display_config: display_config,
                                wv_server_error: null,
                                drl_result: drl_result,
                                loading_viewer: false,
                              },
                              () =>
                                console.log("Selected Record : ", this.state)
                            );
                          }
                        })
                        .catch((err) => {
                          let errorMessage;

                          if (err && err.response) {
                            //read for 404 status
                            if (err.response.status === 404) {
                              errorMessage = "404";
                            } else if (
                              err.response.request &&
                              err.response.request.response
                            ) {
                              let message = JSON.parse(
                                err.response.request.response
                              ).message;
                              if (
                                message === "Retry" ||
                                message === "Timeout"
                              ) {
                                errorMessage = message;
                              } else {
                                errorMessage =
                                  "Error retreiving file from DRL.";
                              }
                            }
                          } else if (err && err.message) {
                            errorMessage = err.message;
                          }
                          if (
                            this.state.selected_record ===
                            iu_record.iu_record_id
                          ) {
                            this.setState(
                              {
                                ...this.state,
                                display_config: display_config,
                                wv_server_error: null,
                                wv_server_url: wv_server,
                                drl_result: errorMessage,
                                loading_viewer: false,
                              },
                              () =>
                                console.log("Selected Record : ", this.state)
                            );
                          }
                        });
                    } else {
                      if (
                        this.state.selected_record === iu_record.iu_record_id
                      ) {
                        this.setState({
                          ...this.state,
                          display_config: display_config,
                          wv_server_error: null,
                          wv_server_url: wv_server,
                          file_id: iu_record.source_link.file_id,
                          drl_result: drl_result,
                          loading_viewer: false,
                        });
                      }
                    }
                  })
                  .catch((err) => {
                    console.log("error in drl", err);
                    if (this.state.selected_record === iu_record.iu_record_id) {
                      this.setState(
                        {
                          ...this.state,
                          display_config: display_config,
                          wv_server_error:
                            "Error Getting World View Server Path",
                          wv_server_url: null,
                          drl_result: drl_result,
                          loading_viewer: false,
                        },
                        () => console.log("Selected Record : ", this.state)
                      );
                    }
                  });
              } else {
                if (this.state.selected_record === iu_record.iu_record_id) {
                  this.setState(
                    {
                      ...this.state,
                      display_config: display_config,
                      wv_server_error: null,
                      drl_result: drl_result,
                      loading_viewer: false,
                    },
                    () => console.log("Selected Record : ", this.state)
                  );
                }
              }
            })
            .catch((err) => {
              if (this.state.selected_record === iu_record.iu_record_id) {
                this.setState({
                  ...this.state,
                  display_config:
                    "Error retreiving display config for this record",
                  loading_viewer: false,
                });
              }
            });
        }
      );
    }
  };

  isDataReadyForDetailViewer = () => {
    if (this.state.drl_result === "404") {
      return "DRL server could not be reached. Please verify if DRL is registered";
    }
    if (this.state.drl_result === "Network Error") {
      return "Network Error. DRL server might be down. Please try after restarting the DRL server.";
    }
    if (this.state.drl_result === "Retry") {
      return "Server is busy processing requests, please try after sometime.";
    }
    if (this.state.drl_result === "Timeout") {
      return "Request timed out.";
    }
    if (this.state.drl_result === "Error retreiving file from DRL.") {
      return "Error retreiving file from DRL.";
    }

    if (this.state.wv_server_error === "Error Getting World View Server Path") {
      return "Error Getting World View Server Path";
    }

    if (
      this.state.display_config ===
      "Error retreiving display config for this record"
    ) {
      return "Error retreiving display config for this record";
    }

    return "Data Ready";
  };

  renderViewer = () => {
    if (this.state.selected_record !== null) {
      if (this.state.loading_viewer === true) {
        return (
          <ThemeProvider theme={blue_theme}>
            <div
              style={{
                width: "100%",
                height: this.state.tab_panel_height,
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          </ThemeProvider>
        );
      } else {
        if (this.state.display_config !== null) {
          if (this.isDataReadyForDetailViewer() !== "Data Ready") {
            return (
              <ThemeProvider theme={blue_theme}>
                <div
                  style={{
                    width: "100%",
                    height: this.state.tab_panel_height,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography color="secondary" variant="caption">
                    {this.isDataReadyForDetailViewer()}
                  </Typography>
                </div>
              </ThemeProvider>
            );
          } else {
            return Viewer(
              {
                id: this.state.selected_record,
                viewer: this.state.display_config.viewer,
                config: this.state.display_config,
                record: this.getRecord(this.state.selected_record),
                edit: false,
              },
              {
                width: this.state.result_width * 0.8,
                height: this.state.tab_panel_height - 50,
                wv_url: this.state.wv_server_url,
                drl_url: this.props.drl_url,
                drl_result: this.state.drl_result,
                search_string: this.props.search_string(),
                file_id: this.state.file_id,
                location_index: this.state.location_index,
                key_terms: this.props.key_terms,
                copy_text: (text) => this.props.copy(text),
                re_attach : this.props.re_attach,
                attach_options : this.props.attach_options,
                re_attach_attachment : (field_option, attachment_object) => this.props.re_attach_attachment(field_option, attachment_object),
                cta_enabled : this.isCTAEnabled(),
                cta_config : this.getCTAConfig(),
                execute_cta : (cta_config, record) => this.props.execute_cta(cta_config, record)
              }
            );
          }
        }
      }
    }
  };

  isCTAEnabled = () => {
    let record = this.getRecord(this.state.selected_record)
    let ic_name = record.iu_key.containment.base.ic_id
    let iu_name = record.iu_key.user_friendly_name

    let ic_index = this.props.cta_config?this.props.cta_config.findIndex(ic => ic.ic_name === ic_name) : -1

    if (ic_index === -1) {
      return false
    } else {
      let iu_index = this.props.cta_config[ic_index].iu.findIndex(iu => iu.iu_name === iu_name)

      if (iu_index === -1) {
        return false
      } else {
        return true
      }
    }
  }

  getCTAConfig = () => {
    let record = this.getRecord(this.state.selected_record)
    let ic_name = record.iu_key.containment.base.ic_id
    let iu_name = record.iu_key.user_friendly_name

    let ic_index = this.props.cta_config? this.props.cta_config.findIndex(ic => ic.ic_name === ic_name) : -1

    if (ic_index === -1) {
      return null
    } else {
      let iu_index = this.props.cta_config[ic_index].iu.findIndex(iu => iu.iu_name === iu_name)

      if (iu_index === -1) {
        return null
      } else {
        return this.props.cta_config[ic_index].iu[iu_index]
      }
    }
  }

  getRecord = (record_id) => {
    console.log("Push Record ID to viewer: ", record_id)
    let results = this.getResults(this.state.tabValue);
    let record_index = results.findIndex((el) => el.iu_record_id === record_id);
    console.log("Pushing Record to Viewer: ", record_index)
    console.log("Pushing Record to Viewer: ",results[record_index])
    return results[record_index];
  };

  renderDetailView = () => {
    console.log("State on Detail View Render :", this.state);
    return (
      <div
        style={{
          width: this.state.result_width * 0.8,
          height: "calc(" + this.state.tab_panel_height + "px - 75px)",
          // overflow : 'scroll',
          backgroundColor: "#f2f2f2",
        }}
      >
        {this.renderViewer()}
      </div>
    );
  };

  getResultCount = (current_ic) => {
    let resultIndex = this.props.results.findIndex(
      (ic) => ic.ic_name === current_ic
    );
    let resultCount = this.props.results[resultIndex].response.result.length;

    return resultCount;
  };

  getTabs = () => {
    let reco_ics = this.props.results.map(result => result.ic_name)
    let class_ics = this.props.class_results.map(result => result.ic_name)
    let all_ics = [...reco_ics, ...class_ics]
    let tabs_set = new Set(all_ics)
    let tabs = Array.from(tabs_set)
    console.log("Tabs :: Recommendation ICs :", reco_ics)
    console.log("Tabs :: Classification ICs :", class_ics)
    console.log("Tabs :: Final Tabs :", tabs)
    return tabs
  }

  renderSearchResult = () => {
    const { classes } = this.props;
    return (
      <ThemeProvider theme={blue_theme}>
        <div>
          <Paper
            ref={this.tab}
            elevation={2}
            square
          >
            <Tabs
              value={this.state.tabValue}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable result tabs"
            >
              {this.props.ic_list.map((ic, i) => {
                return (
                  <Tab
                    style={{
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                    disableRipple={true}
                    wrapped={true}
                    label={
                      <Badge
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        className={classes.badge}
                        overlap="rectangle"
                        badgeContent={this.getResults(i).length}
                        color={
                          this.state.tabValue === i ? "primary" : "default"
                        }
                        showZero
                      >
                        <Tooltip title={ic}>
                          <Typography
                            style={{ textOverflow: "ellipsis" }}
                            variant="body2"
                          >
                            {ic}
                          </Typography>
                        </Tooltip>
                      </Badge>
                    }
                  />
                );
              })}
            </Tabs>
          </Paper>
          {this.renderTabPanel()}
        </div>
      </ThemeProvider>
    );
  };

  renderContainer = () => {
    return (
      <div
        style={{
          width: this.props.width,
          height: this.props.height,
          display : 'flex',
          flexDirection : 'row'
        }}
      >
        <div style = {{width : this.state.result_width}}>
          {this.renderSearchResult()}
        </div>
        {this.renderClassResults()}
      </div>
    )
  }

  render() {
    const { classes } = this.props;
    console.log("Props Width : ", this.props.width)
    console.log("Props Height : ", this.props.height)
    return this.renderContainer();
  }
}

export default withStyles(styles)(Result);
